<template>
  <!-- listing管理表 -->
  <div>
    <div style="margin-top: 15px;">
      <el-input placeholder="请输入搜索内容" v-model="searchBar" class="input-with-select" clearable>
        <el-select v-model="select" slot="prepend" placeholder="请选择" clearable>
          <el-option label="ASIN" value="likeAll_asin"></el-option>
          <el-option label="内部SKU" value="likeAll_psku"></el-option>
          <el-option label="卖家SKU" value="likeAll_msku"></el-option>
          <el-option label="销售姓名" value="likeAll_sellerName"></el-option>
          <el-option label="产品店铺名" value="likeAll_storeName"></el-option>
          <el-option label="客服姓名" value="likeAll_supportName"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
      </el-input>
    </div>

    <div class="listing">
      <!--      @selection-change="handleSelectionChange"-->
      <el-table :data="tableData" style="width: 100%" ref="out-table">
        <!--        <el-table-column-->
        <!--            type="selection"-->
        <!--            width="55">-->
        <!--        </el-table-column>-->
        <el-table-column label="ASIN" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.asin }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内部SKU" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.psku }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卖家SKU" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.msku }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售姓名" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sellerName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客服姓名" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.supportName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品店铺名" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.storeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250px">
          <template slot="header">
            <el-button type="primary" size="mini" @click="AddDialogVisible = true">新增</el-button>
            <!-- 导入 -->
            <el-upload
                class="upload-demo"
                action="string"
                :limit="1"
                :before-upload="handleBeforeUpload"
                :http-request="husinessLicenseHandler"
                :show-file-list="false"
                ref="upload"
                :file-list="fileList">
              <el-button size="mini" type="success" :loading="uploadLoading">导入</el-button>
            </el-upload>
            <el-button :loading="downloadLoading" type="warning" size="mini" @click="exportExcel()">导出</el-button>
          </template>
          <template slot-scope="scope">
            <el-button size="mini" @click="EditList(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.listingId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <div class="block">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="size"
            :page-sizes="[5, 10, 20,30,50,60,70,100]"
            layout="sizes,prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
      <!-- 新增的对话框 -->
      <el-dialog title="Listing管理表" :visible.sync="AddDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="80px" :model="addForm">
          <el-form-item label="ASIN">
            <el-input v-model="addForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="addForm.psku"></el-input>
          </el-form-item>
          <el-form-item label="卖家SKU">
            <el-input v-model="addForm.msku"></el-input>
          </el-form-item>
          <el-form-item label="销售姓名">
            <el-input v-model="addForm.sellerName"></el-input>
          </el-form-item>
          <el-form-item label="客服姓名">
            <el-input v-model="addForm.supportName"></el-input>
          </el-form-item>
          <el-form-item label="产品店铺名">
            <el-input v-model="addForm.storeName"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="AddDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑的对话框 -->
      <el-dialog title="Listing管理表" :visible.sync="editDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="80px" :model="editForm">
          <el-form-item label="ASIN">
            <el-input v-model="editForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="editForm.psku"></el-input>
          </el-form-item>
          <el-form-item label="卖家SKU">
            <el-input v-model="editForm.msku"></el-input>
          </el-form-item>
          <el-form-item label="销售姓名">
            <el-input v-model="editForm.sellerName"></el-input>
          </el-form-item>
          <el-form-item label="客服姓名">
            <el-input v-model="editForm.supportName"></el-input>
          </el-form-item>
          <el-form-item label="产品店铺名">
            <el-input v-model="editForm.storeName"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiAddListingList,
  apiEditListingList,
  apiDeleteListingList,
  apiSearchListingList,
  exportTable,
  apiImportFile
} from "../../api/listing";
// import { getToken } from '../../utils/token';
export default {
  data() {
    return {
      id: "",
      role: "",
      //输入框
      searchBar: "",
      select: "",
      searchDate: {},
      AddDialogVisible: false,
      editDialogVisible: false,
      downloadLoading: false,
      uploadLoading: false,
      labelPosition: "right",
      //新增表单数据：
      addForm: {sellerName: JSON.parse(window.localStorage.getItem('userName'))},
      //编辑表单数据：
      editForm: {},
      //分页器数据
      currentPage: 1, //默认第一页 当前页
      size: 10,
      total: 0,//总条数
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      tableData: [],
      fileList: [],
      multipleSelection: []//checkbox初始值
    };
  },

  methods: {
    // 分页选择条数触发
    handleSizeChange(size) {
      this.size = size;
      this.search(false);
    },
    // 分页选择页面触发
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.search(false);
    },
    // 搜索
    search(boolean) {
      // 输入框添加一个判断
      delete this.searchDate.likeAll_asin;
      delete this.searchDate.likeAll_psku;
      delete this.searchDate.likeAll_msku;
      delete this.searchDate.likeAll_sellerName;
      delete this.searchDate.likeAll_storeName;
      delete this.searchDate.likeAll_supportName;
      if (!(this.common.isBlank(this.select))) {
        this.$set(this.searchDate, this.select, this.searchBar)
      }
      this.searchDate = this.common.clearNull(this.searchDate);
      this.currentPage = boolean ? 1 : this.currentPage;
      apiSearchListingList({
        page: this.currentPage,
        size: this.size,
        q: JSON.stringify(this.searchDate),
        sort: "listingId",
        direction: "DESC",
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements
          if (boolean) {
            this.$message.success(res.data.message);
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //点击确定按钮新增数据
    submitAdd() {
      apiAddListingList(this.addForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.AddDialogVisible = false;
          this.addForm = {};
          this.search(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },

    //点击编辑回传数据
    //修改表单数据 双向修改改成深拷贝
    EditList(data) {
      this.editDialogVisible = true;
      this.editForm = JSON.parse(JSON.stringify(data));
    },
    //点击编辑按钮修改数据
    submitEdit() {
      apiEditListingList(this.editForm.listingId, this.editForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.editDialogVisible = false;
          this.editForm = {};
          this.search(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },

    //删除数据
    handleDelete(id) {
      // 提示用户是否删除
      this.$confirm('是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiDeleteListingList(id).then((res) => {
          if (res.data.code === 200) {
            this.search(false);
            this.$message.success(res.data.message);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //导入
    handleBeforeUpload(file) {//上传文件之前的钩子，参数为上传的文件
      if (file.name.indexOf("xls") === -1 && file.name.indexOf("xlsx") === -1) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return false;
      }
    },
    // 成功
    husinessLicenseHandler(params) {//覆盖
      this.uploadLoading = true;
      const _file = params.file;
      var formData = new FormData()// 通过 FormData 对象上传文件
      formData.append('file', _file)
      apiImportFile(formData).then((res) => {
        if (res.data.code == 200) {

          this.$message({
            message: res.data.message,
            type: 'success'
          });
          this.search(false);
        } else {
          this.$message.error('导入失败');
        }
      }).finally(() => {
        this.fileList = [];
        this.uploadLoading = false;
      })
    },

    // 导出
    async exportExcel() {
      this.downloadLoading = true;
      try {
        if (this.total > 100000) {
          this.$message.error("数据量太大，一共有" + this.total + "条数据，请你筛选你需要的范围数据或者分段下载，不能超出十万条数据");
          return;
        }

        this.searchBar = this.common.clearNull(this.searchBar);

        var fileName = "Listing管理.xlsx";
        let blobRes = await exportTable({
          q: JSON.stringify(this.searchDate),
        });
        let blob = new Blob([blobRes.data], {
          type: "application/octet-stream",
        });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      } finally {
        this.downloadLoading = false
      }

    },

  },

  //一点进来 就获取全部数据
  created() {
    this.search(true);
  },
};
</script>

<style lang='less' scoped>
.el-input-group {
  margin-left: 30px;
  width: 500px;
}

.listing {
  padding: 50px 30px;

  .el-pagination {
    padding: 32px 0px;
  }
}

// .upload-demo{
//   display: inline-block;
//   margin: 0px 10px;
// }
</style>